module.exports = __webpack_public_path__ + "static/media/evento-carioca-anime-canopla-personalizada.db27c513.jpg";